import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.skin)?_c('div',{staticClass:"skin-character-cell"},[_c(VAvatar,{staticClass:"skin-avatar",attrs:{"size":"32"}},[_c(VImg,{attrs:{"src":_vm.skin.imageUrl,"alt":_vm.skin.name}})],1),_c('span',{staticClass:"skin-name"},[_vm._v(_vm._s(_vm.skin.name))])],1):_c('span',{staticClass:"skin-empty"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }